import React, { useMemo } from 'react';
import moment from 'moment-jalaali';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { downloadTypes } from './DownloadDataTypes';
import Form from '../../Components/Boilerplates/Forms/Forms';
// import { useEffect } from 'react';

const DownloadData = () => {
  const { type } = useParams();
  const thisPageData = useMemo(() => ({ ...downloadTypes[type] }), [type]);
  const token = useSelector((state) => state.auth.Token);

  const allInputs = useMemo(() => {
    if (!thisPageData.inputs) {
      return null;
    }

    const inputs = thisPageData.inputs.slice();

    inputs.push(
      {
        id: 'start_date',
        elementConfig: {
          type: 'calendar',
          placeholder: 'تاریخ شروع',
        },
        value: moment(),
        requestValue: moment().format('YYYY-MM-DD'),
        validation: {
          required: true,
        },
        valid: true,
        touched: true,
        queryParams: true,
      },
      {
        id: 'end_date',
        elementConfig: {
          type: 'calendar',
          placeholder: 'تاریخ پایان',
        },
        value: moment(),
        requestValue: moment().format('YYYY-MM-DD'),
        validation: {
          required: true,
        },
        valid: true,
        touched: true,
        queryParams: true,
      }
    );

    return inputs;
  }, [thisPageData]);

  return (
    <Form
      inputs={allInputs}
      url={thisPageData.url}
      method={'GET'}
      pageTitle={'دانلود'}
      header={{ Authorization: `Bearer ${token}` }}
      goBack='/'
      responseFunction={true}
    />
  );
};

export default DownloadData;
